export class HostFamilyBase {

    constructor(public $uibModal, public InterestedHostFamiliesDetails, public $state, public applicationId) {

    }

    openHostFamily(hf) {
        var param = {
            hostFamilyId: hf.hostFamilyId
        };

        let url = this.$state.href('^.interestedFamily', param);
        window.open(url, '_blank');
    }

    openFeedbackDialog(hf, intrested: boolean) {

        let hideForm = hf.proposalStatusCode == 'O' && hf.proposalSubstatusCode == 'APSNT';

        var skipCheck = intrested !== true || hf.proposalId

        var template = intrested
            ? 'areas/hostFamilies/hostFamilyFeedback/hostFamilyPositiveFeedbackModal.html'
            : 'areas/hostFamilies/hostFamilyFeedback/hostFamilyNegativeFeedbackModal.html';

        return this.$uibModal.open({
            templateUrl: template,
            controller: 'HostFamilyFeedbackModalController as $ctrl',
            backdrop: false,
            size: 'lg',
            resolve: {
                proposalId: () => hf.proposalStatusCode != 'C' ? hf.proposalId : undefined,
                requestId: () => hf.proposalStatusCode != 'C' ? hf.requestId : undefined,
                interested: () => intrested,
                hostFamilyId: () => hf.hostFamilyId,
                applicationId: () => this.applicationId,
                familyFullName: () => hf.familyFullName,
                hideForm: () => hideForm,
                canlike: () => skipCheck
                    ? true
                    : this.InterestedHostFamiliesDetails.limits({ applicationId: this.applicationId })
                        .$promise
                        .then((limits) => limits.currentLikes < limits.maxLikes)
            },
            params: {
                proposalId: hf.proposalStatusCode != 'C' ? hf.proposalId : null,
                requestId: hf.proposalStatusCode != 'C' ? hf.requestId : null,
                interested: null,
                reasonToDeclineCode: null,
                hostFamilyId: hf.hostFamilyId,
                applicationId: this.applicationId,
                familyFullName: hf.familyFullName,
                hideForm: () => hideForm
            }
        });
        
    }

}